import React, { useEffect, useState, useRef } from "react";
import { FaSave, FaSearch, FaTrash } from "react-icons/fa";
import es_ES from "rsuite/locales/es_ES";
import {
  Modal,
  Panel,
  DatePicker,
  Text,
  NumberInput,
  Button,
  Table,
  Input,
  toaster,
  Message,
  SelectPicker,
  CustomProvider,
  CheckPicker,
} from "rsuite";
import { InputNumber, Select } from "antd";
import moment from "moment/moment";
import {
  cancelHorario,
  eliminaHorarios,
  getHorariosServicio,
  saveHorario,
  getCatServicios,
  getEspacios,
  saveEspacio,
} from "./Services/HorariosServices";
import { LayoutHome } from "./LayoutHome";

const { Column, HeaderCell, Cell } = Table;

export const Horarios = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const initialized = useRef(false);
  const [fec1, setFec1] = useState("");
  const [fec2, setFec2] = useState("");
  const [del, setDel] = useState(moment(new Date()).format("DD/MM/YYYY"));
  const [al, setAl] = useState(moment(new Date()).format("DD/MM/YYYY"));
  const [duracion, setDuracion] = useState(null);
  const [horaIni, setHoraIni] = useState("");
  const [horaFin, setHoraFin] = useState("");
  const [horaIniCom, setHoraIniCom] = useState("");
  const [horaFinCom, setHoraFinCom] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [habilitarElimina, setHabilitarElimina] = useState(true);
  const [pregunta, setPregunta] = useState("");
  const [disabledSi, setDisabledSi] = useState(false);
  const [idServFiltro, setIdServFiltro] = useState("0");
  const [listServicios, setListServicios] = useState([
    { label: "--SELECCIONA UNA OPCIÓN--", value: "0" },
  ]);
  const [idServicio, setIdServicio] = useState("0");
  const [disabledControls, setDisabledControls] = useState(true);
  const [dataCondcion] = useState([
    { label: "Sin selección", value: "SinSelecc" },
    { label: "Excluir fines de semana", value: "excludFS" },
    { label: "Excluir domingo", value: "excludDom" },
    { label: "Solo sábados", value: "soloSAB" },
    { label: "Solo domingos", value: "soloDOM" },
    { label: "Lunes", value: "Lunes" },
    { label: "Martes", value: "Martes" },
    { label: "Miercoles", value: "Miercoles" },
    { label: "Jueves", value: "Jueves" },
    { label: "Viernes", value: "Viernes" },
  ]);
  const [condicion, setCondicion] = useState(["SinSelecc"]);
  const [dataFiltro] = useState([
    { label: "Todos los Lunes", value: "LUNES" },
    { label: "Todos los Martes", value: "MARTES" },
    { label: "Todos los Míercoles", value: "MIÉRCOLES" },
    { label: "Todos los Jueves", value: "JUEVES" },
    { label: "Todos los Viernes", value: "VIERNES" },
    { label: "Todos los Sábados", value: "SÁBADO" },
  ]);
  const [filtro, setFiltro] = useState("0");
  const [openElimina, setoOpenElimina] = useState(false);
  const [espacios, setEspacios] = useState(0);

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" },
    );
  };

  const loadServicios = async () => {
    await getCatServicios(idNegocio).then((response) => {
      setListServicios((prev) => [...prev, ...response]);
    });
  };

  const maskTime = (value, opc) => {
    if (opc === "ini") {
      setHoraIni(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
    if (opc === "fin") {
      setHoraFin(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
    if (opc === "iniCom") {
      setHoraIniCom(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
    if (opc === "finCom") {
      setHoraFinCom(
        value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d)/, "$1:$2")
          .replace(/(\d{2})(\d)/, "$1:$2"),
      );
    }
  };

  const activateControls = async (e) => {
    setIdServicio(e);
    if (e === "0") {
      setEspacios(0);
      setDisabledControls(true);
    } else {
      await getEspacios(idNegocio, e).then((res) => {
        setEspacios(res);
        setDisabledControls(false);
      });
    }
  };

  const getHorarios = async () => {
    if (del === null || al === null) {
      return;
    }
    var f1 = new Date(del).toISOString().substring(0, 10);
    var f2 = new Date(al).toISOString().substring(0, 10);

    if (filtro === "" || filtro === null) {
      setTimeout(() => {
        setFiltro("0");
      }, [500]);
    }

    setDataLoading(true);
    await getHorariosServicio(idNegocio, idServFiltro, f1, f2, filtro)
      .then((res) => {
        setData(res);
        setDataLoading(false);
        if (res.length > 0) setHabilitarElimina(false);
      })
      .finally((end) => {
        setDataLoading(false);
      });
  };

  const save = async () => {
    setLoading(true);

    const data = {
      id: idNegocio,
      del: moment(fec1).format("YYYY-MM-DD"),
      al: moment(fec2).format("YYYY-MM-DD"),
      idServicio: idServicio,
      espacio: espacios,
      duracion: duracion,
      horaIni: horaIni,
      horaFin: horaFin,
      horaIniCom: horaIniCom,
      horaFinCom: horaFinCom,
      condicion: condicion,
    };

    await saveHorario(data)
      .then((res) => {
        if (res.data > 0) {
          toast("Los datos se han actualizado de forma correcta.", "success");
          setTimeout(() => {
            setLoading(false);
            window.location.reload();
          }, [600]);
        } else {
          toast("Ocurrio un error al guardar el horario.", "warning");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const cancelarHorario = async (props) => {
    const _fec = moment(props.fecha, "DD-MM-YYYY").toDate();

    const data = {
      id: idNegocio,
      del: _fec,
      al: _fec,
      espacio: props.espacio,
      duracion: 0,
      horaIni: props.hora,
      horaFin: "00:00",
      horaIniCom: "00:00",
      horaFinCom: "00:00",
    };

    await cancelHorario(data).then((res) => {
      console.log(res);
      if (res.data === 1) {
        toast("El horario se ha cancelado de forma correcta.", "success");
        getHorarios();
      }
      if (res.data === -1) {
        toast(
          "El horario no puede ser cancelado, la fecha es menor a la actual.",
          "error",
        );
      }
      if (res.data === -2) {
        toast(
          "El horario no puede ser cancelado, la hora es menor a la actual.",
          "error",
        );
      }
      if (res.data === -3) {
        toast(
          "El horario no puede ser cancelado, se encuentra ocupado.",
          "error",
        );
      }
    });
  };

  const updateEspacios = async () => {
    const data = {
      id: idNegocio,
      idServicio: idServicio,
      espacios: espacios,
    };

    await saveEspacio(data).then((res) => {
      if (res.data > 0) {
        toast("Se actualizo la infirmación de forma correcta.", "success");
      } else {
        toast("Ocurrio un error al enviar la información", "Error");
      }
    });
  };

  const handleFiltroServicio = (e) => {
    setIdServFiltro(e);
  };

  const handleOpenElimina = () => {
    const _f1 = moment(del).format("DD-MMM-YYYY");
    const _f2 = moment(al).format("DD-MMM-YYYY");
    setDisabledSi(false);
    setPregunta(
      `¿Deseas eliminar los horarios con el rango de fechas: Del ${_f1} al ${_f2}?`,
    );
    setoOpenElimina(true);
  };

  const deleteHorarios = async () => {
    setDisabledSi(true);
    const data = {
      id: idNegocio,
      del: moment(del).format("YYYY-MM-DD"),
      al: moment(al).format("YYYY-MM-DD"),
    };

    await eliminaHorarios(data)
      .then((res) => {
        if (res.data > 0) {
          toast(`Se han eliminado: ${res.data}, registro(s).`, "success");
          setHabilitarElimina(true);
          setoOpenElimina(false);
          getHorarios();
        }
      })
      .catch((msj) => {
        console.log(msj);
      });
  };

  const handleChangeCondicion = (e) => {
    if (e === null) {
      setCondicion(["SinSelecc"]);
    } else {
      setCondicion(e);
    }
  };

  const handleEspacios = (e) => {
    if (e === null) {
      setEspacios(1);
    } else {
      setEspacios(e);
    }
  };

  const handleCloseElimina = () => {
    setoOpenElimina(false);
  };

  const handleDisabledDate = (date) => {
    return date.getTime() < moment().startOf("day").valueOf();
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadServicios();
    }
  }, []);

  return (
    <>
      <LayoutHome title={"Horarios"} selectedKey={"13"}>
        <Panel bordered header="Creación de Horarios">
          <div className="row mb-3">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Text size={"md"}>Servicio</Text>
              <Select
                style={{ width: "100%" }}
                defaultValue={"0"}
                options={listServicios}
                onChange={(e) => activateControls(e)}
                block
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Disponibilidad por Horario</Text>
              <InputNumber
                value={espacios}
                min={1}
                onChange={(e) => handleEspacios(e)}
                style={{ width: "100%" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <br></br>
              <Button
                startIcon={<FaSave></FaSave>}
                appearance="primary"
                onClick={() => updateEspacios()}
                disabled={idServicio === "0" ? true : false}
              >
                Guardar
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Fecha inicial</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker
                  block
                  shouldDisableDate={handleDisabledDate}
                  disabled={disabledControls}
                  onChange={(e) => setFec1(e)}
                />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Fecha final</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker
                  block
                  disabled={disabledControls}
                  shouldDisableDate={handleDisabledDate}
                  onChange={(e) => setFec2(e)}
                />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Condiciones</Text>
              <CheckPicker
                data={dataCondcion}
                block
                disabled={disabledControls}
                defaultValue={["SinSelecc"]}
                searchable={false}
                placeholder="Selecciona"
                onChange={(e) => handleChangeCondicion(e)}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Duración</Text>
              <NumberInput
                controls={false}
                min={0}
                disabled={disabledControls}
                value={duracion}
                onChange={(e) => setDuracion(e)}
                style={{ textAlign: "center" }}
              />
              <span style={{ fontSize: "12px" }}>Minutos</span>
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Hora Inicio</Text>
              <Input
                disabled={disabledControls}
                placeholder="00:00"
                maxLength={5}
                value={horaIni}
                onChange={(e) => maskTime(e, "ini")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Última hora</Text>
              <Input
                disabled={disabledControls}
                placeholder="00:00"
                maxLength={5}
                value={horaFin}
                onChange={(e) => maskTime(e, "fin")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Ini. comida</Text>
              <Input
                placeholder="00:00"
                maxLength={5}
                disabled={disabledControls}
                value={horaIniCom}
                onChange={(e) => maskTime(e, "iniCom")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <Text size={"md"}>Fin comida</Text>
              <Input
                disabled={disabledControls}
                placeholder="00:00"
                maxLength={5}
                value={horaFinCom}
                onChange={(e) => maskTime(e, "finCom")}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1">
              <br />
              <Button
                disabled={disabledControls}
                appearance="primary"
                onClick={save}
                loading={loading}
                block
                startIcon={<FaSave></FaSave>}
              >
                Guardar
              </Button>
            </div>
          </div>
        </Panel>
        <br />

        <Panel header="Consulta de Horarios de Servicio" bordered>
          <div className="row mb-2">
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Text size={"md"}>Filtrar por Servicio</Text>
              <Select
                style={{ width: "100%" }}
                defaultValue={"0"}
                options={listServicios}
                onChange={(e) => handleFiltroServicio(e)}
                block
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Del</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker value={del} onChange={(e) => setDel(e)} />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Al</Text>
              <CustomProvider locale={es_ES}>
                <DatePicker value={al} onChange={(e) => setAl(e)} />
              </CustomProvider>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <Text size={"md"}>Filtro de búsqueda</Text>
              <SelectPicker
                block
                searchable={false}
                data={dataFiltro}
                onChange={(e) => setFiltro(e)}
                value={filtro}
                placeholder="Todos los días"
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <Button appearance="primary" onClick={getHorarios}>
                <FaSearch></FaSearch>&nbsp; Buscar
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Table
                height={300}
                hover={true}
                showHeader={true}
                data={data}
                loading={dataLoading}
                bordered={true}
                cellBordered={true}
                headerHeight={30}
                rowHeight={40}
              >
                <Column flexGrow={1} sortable>
                  <HeaderCell align="center">Fecha</HeaderCell>
                  <Cell dataKey="fecha" align="center" />
                </Column>

                <Column flexGrow={1} sortable>
                  <HeaderCell>Día</HeaderCell>
                  <Cell dataKey="diaSemana"></Cell>
                </Column>

                <Column flexGrow={1} resizable sortable>
                  <HeaderCell align="center">Horario</HeaderCell>
                  <Cell dataKey="hora" align="center" />
                </Column>

                <Column flexGrow={1} resizable sortable>
                  <HeaderCell align="center">Espacios</HeaderCell>
                  <Cell dataKey="espacios" align="center" />
                </Column>

                <Column flexGrow={1} resizable sortable>
                  <HeaderCell align="center">Duración</HeaderCell>
                  <Cell dataKey="intervarlo" align="center" />
                </Column>

                <Column width={100} fixed>
                  <HeaderCell align="center">Acción</HeaderCell>
                  <Cell style={{ padding: "6px" }} align="center">
                    {(rowData) => (
                      <Button
                        appearance="subtle"
                        size="sm"
                        onClick={() =>
                          cancelarHorario({
                            id: idNegocio,
                            fecha: rowData.fecha,
                            espacio: rowData.espacios,
                            hora: rowData.hora,
                          })
                        }
                      >
                        <FaTrash style={{ color: "red" }} />
                      </Button>
                    )}
                  </Cell>
                </Column>
              </Table>
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <Text color="red" size="lg">
                * Nota: Solo se eliminaran aquellos horarios que no se
                encuentren agendados.
              </Text>
            </div>
            <div className="text-end col-lg-6 col-md-6 col-sm-6">
              <Button
                appearance="primary"
                color="red"
                disabled={habilitarElimina}
                onClick={() => handleOpenElimina(true)}
              >
                Eliminar horarios
              </Button>
            </div>
          </div>
        </Panel>

        <Modal
          centered
          size="xs"
          open={openElimina}
          onClose={handleCloseElimina}
        >
          <Modal.Header>
            <Modal.Title>Eliminar horarios</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Text size="md" color="red">
              {pregunta}
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseElimina} appearance="subtle">
              Cerrar
            </Button>
            <Button
              disabled={disabledSi}
              onClick={() => deleteHorarios()}
              appearance="primary"
            >
              Si
            </Button>
          </Modal.Footer>
        </Modal>
      </LayoutHome>
    </>
  );
};
